import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';

PlotlyModule.forRoot(PlotlyJS);

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  if (!environment.production) {
    console.error(err);
  }
});
